function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.16667,0,0,1.21739,-5,-2.86957)"
}, React.createElement("path", {
  d: "M31.286,15.5C31.286,8.468 25.337,2.768 18,2.768C14.717,2.768 11.55,3.933 9.11,6.038C8.583,6.493 8.54,7.273 9.015,7.778C9.49,8.284 10.303,8.325 10.831,7.869C12.798,6.172 15.352,5.232 18,5.232C23.917,5.232 28.714,9.829 28.714,15.5C28.714,16.18 29.29,16.732 30,16.732C30.71,16.732 31.286,16.18 31.286,15.5Z"
}));
var SvgBusy = function SvgBusy(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBusy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/busy.1709b165.svg";
export { ForwardRef as ReactComponent };